module.exports = __webpack_public_path__ + "static/media/data_3.cdafe7d9.mp4";